
export const leadsList = (
    { setModalData }: {
        setModalData?: (data: { modalType: string; data: { id: number | undefined } }) => void
    }) => {

    return [
        {
            Header: "Name",
            accessor: "info",
            Cell: ({ row }: any) => {

                const { first_name, last_name } = row.original.info;

                return (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setModalData && setModalData({ modalType: "leads", data: { id: row.original.id } })}
                    >
                        {first_name} {last_name}
                    </span>
                );
            },
            id: 1,
            isChecked: true,
        },
        {
            Header: "Consultant",
            accessor: "assigned_to",
            Cell: ({ row }: any) => {

                return (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setModalData && setModalData({ modalType: "leads", data: { id: row.original.id } })}
                    >
                        {row.original.assigned_to || "Not available"}
                    </span>
                );
            },
            id: 2,
            isChecked: true,
        },
        {
            Header: "Birthdate",
            accessor: "info.birthdate",
            Cell: ({ row }: any) => {

                return (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setModalData && setModalData({ modalType: "leads", data: { id: row.original.id } })}
                    >
                        {row.original.info.birthdate || "Not available"}
                    </span>
                );
            },
            id: 3,
            isChecked: true,
        },
        {
            Header: "Address",
            accessor: "info.address",
            Cell: ({ row }: any) => {

                return (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setModalData && setModalData({ modalType: "leads", data: { id: row.original.id } })}
                    >
                        {row.original.info.address || "Not available"}
                    </span>
                );
            },
            id: 4,
            isChecked: true,
        },
        {
            Header: "Email",
            accessor: "info.email",
            Cell: ({ row }: any) => {

                return (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setModalData && setModalData({ modalType: "leads", data: { id: row.original.id } })}
                    >
                        {row.original.info.email || "Not available"}
                    </span>
                );
            },
            id: 5,
            isChecked: true,
        },
        {
            Header: "Phone",
            accessor: "info.phone",
            Cell: ({ row }: any) => {

                return (
                    <span
                        style={{ cursor: "pointer" }}
                        onClick={() => setModalData && setModalData({ modalType: "leads", data: { id: row.original.id } })}
                    >
                        {row.original.info.phone || "Not available"}
                    </span>
                );
            },
            id: 6,
            isChecked: true,
        }
    ];
}
